<template>
  <section id="Outline" class="g_section">
    <div class="g_bg_text">
      <KinesisScroll
        tag="img"
        :src="'./static/hd_outline.svg'"
        :strength="100"
        type="translate"
        axis="y"
      />
    </div>
    <div class="g_hd_en_wrap">
      <FxText>
        <p class="g_hd_en">OUTLINE</p>
      </FxText>
    </div>
    <div class="g_hd_ja_wrap">
      <FxText>
        <h2 class="g_hd_ja">イベント概要</h2>
      </FxText>
    </div>
    <div class="content_body">
      <p class="mainlead">
        「バーチャルマーケット4」の見所を部分的に反映したワールドを採用し、ニコニコ生放送での生中継やVR内購入体験イベントを実施します。
      </p>
      <div class="g_frame padding_right">
        <KinesisScroll
          tag="img"
          :src="'./static/img_vcc.svg'"
          :strength="-40"
          type="translate"
          axis="y"
          class="vcc"
        />
        <h3 class="head">
          購入体験用<br class="ui_sm" />10,000VCC<br
            class="ui_md"
          />プレゼント中！
        </h3>
        <p>
          イベント開催中、<br class="g_ui_md" />THE SEED
          ONLINEのアカウントを持っているユーザーは<br
            class="g_ui_md"
          />公式スタジオに並ぶ商品をすべて購入できる分の<strong>10,000VCC</strong>を獲得できます！<br />
          <strong>※ 配布は終了いたしました</strong>
        </p>
        <p class="notice">
          ※
          VCC（バーチャルキャストクレジット）とは、バーチャルキャスト周辺サービスで使用可能な仮想通貨になります。<br />
          ※
          体験版VCCの有効期限はイベント終了後までとなりますが、購入体験を行ったアイテムは残ります。
        </p>
        <p class="control">
          <a
            href="https://seed.online/register"
            target="_blank"
            class="g_link_button"
            >THE SEED ONLINEで今すぐ登録する</a
          >
        </p>
      </div>
      <div class="g_frame howto_wrap">
        <h3 class="head">
          THE SEED ONLINEに登録して、<br
            class="ui_md"
          />バーチャルキャストで連携！
        </h3>
        <div class="howto">
          <div class="howto_item">
            <img src="../../assets/img_howto1.png" alt="" />
            <p>
              1. THE SEED ONLINEでアカウントを作成します。
              （作成済みの場合この作業は不要です）
            </p>
          </div>
          <div class="howto_way">
            <img src="../../assets/img_way_right.svg" alt="" />
          </div>
          <div class="howto_item">
            <img src="../../assets/img_howto2.png" alt="" />
            <p>
              2. バーチャルキャストを起動し、タイトル画面右上より、THE SEED
              ONLINEと連携します。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FxText from "../atoms/FxText";
import { KinesisScroll } from "vue-kinesis";
export default {
  name: "Outline",
  components: { KinesisScroll, FxText }
};
</script>

<style scoped>
.vcc {
  position: absolute;
  right: -160px;
  top: -80px;
  width: 42%;
}
.mainlead {
  font-size: 1.25rem;
  margin: 0 0 3rem;
}
.head {
  font-feature-settings: "palt";
  font-size: 2.5rem;
  line-height: 1;
  margin: 0 0 2rem;
  font-weight: 900;
}
.notice {
  font-size: 0.8rem;
  margin-bottom: 1.5rem;
}
.padding_right {
  padding-right: 28%;
}
.control {
  margin: 0;
}
.howto_wrap {
  margin: 4rem 0;
}
.howto {
  display: flex;
  justify-content: center;
}
.howto_wrap h3 {
  font-size: 1.75rem;
  text-align: center;
}
.howto_item {
  width: 45%;
}
.howto_item img {
  width: 100%;
}
.howto_way {
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.howto_way img {
  margin: -80% 0 0;
}
.ui_sm,
.ui_md {
  display: none;
}
@media screen and (max-width: 1360px) {
  .vcc {
    right: -4%;
    top: -8%;
    width: 32%;
  }
}
@media screen and (max-width: 850px) {
  .head {
    line-height: 1.25;
    margin: 0 0 1rem;
  }
  .ui_md {
    display: inherit;
  }
  .vcc {
    width: 32%;
    top: -12%;
  }
  .padding_right {
    padding-right: 40px;
  }
}
@media screen and (max-width: 768px) {
  .vcc {
    width: 22%;
    top: -2%;
  }
  .mainlead {
    font-size: 1rem;
  }
  .padding_right {
    padding-right: 20px;
  }
  .head {
    font-size: 2.5rem;
  }
}
@media screen and (max-width: 630px) {
  .head {
    font-size: 2rem;
  }
  .howto_wrap h3 {
    font-size: 1.5rem;
  }
  .howto {
    flex-direction: column;
  }
  .howto_item {
    width: 100%;
  }
  .howto_way {
    display: none;
  }
}
@media screen and (max-width: 480px) {
  .ui_sm {
    display: inherit;
  }
  .howto_wrap h3 {
    font-size: 1.1rem;
  }
  .vcc {
    width: 32%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheOutlineSection.vue